import { SVGPureIcon } from "@/ui"
import { Tooltip } from "antd"
import client from "@/store/client"
import globalStore from "@/store/global"
import inputTypeStore from "../input-file/input-type"
import { HelperCore } from "@/common/dependencies"
import knowledgeChoiceStore from "../knowledge-choice/store"
import modelChoiceStore from "../model-choice/store"
import { useMemo } from "react"
import userStore from "@/store/user"
import { useLocation } from "react-router-dom"
import { observer } from "mobx-react-lite"

function ScreenShot(props) {
  // console.info('>>> 启用截图功能', client.isLLQ, client.versionGt("1.3.1146.60"), client.version)
  const {
    className,
    simple,
    isShowSo,
  } = props;

  const isUseNetwork = globalStore.is_so && isShowSo;
  const isUseKnowledge = knowledgeChoiceStore.curId;
  const currentLocation = useLocation();
  const disabeldToolTip = useMemo(() => {
    if(isUseNetwork){
      return `联网搜索不支持`;
    }
    if(isUseKnowledge && !(currentLocation.pathname != "/chathome")){
      return `选择知识库后不支持`;
    }
    return '';
  }, [isUseNetwork, isUseKnowledge, currentLocation]);

  return (
    <Tooltip title={disabeldToolTip ? `${disabeldToolTip}上传截图` : '截图提问'}>
      <button
        onClick={() => {
          if(disabeldToolTip){
            return;
          }
          if (!userStore.isUser) {
            userStore.gotoLogin();
            return;
          }

          client.run("OnSnapShot", (data, msg) => {
            let imageData = data.imageData || data
            // 添加一个由 screenshot + 当前时间戳组成的文件名
            const fileName = 'screenshot_' + Date.now() + '.png'
            // 检查 imageData 是否有前缀 data:image/png;base64,
            if (imageData.startsWith('data:image/png;base64')) {
              // 直接使用 imageData
              imageData = HelperCore.base64ToFile(imageData, fileName)
              inputTypeStore.updateTempData('tempFile', [imageData])
            } else {
              // 添加前缀 data:image/png;base64,
              imageData = 'data:image/png;base64,' + imageData
              imageData = HelperCore.base64ToFile(imageData, fileName)
              inputTypeStore.updateTempData('tempFile', [imageData])
            }
             // 截图结束后关闭联网搜索
             globalStore.robotOnlineSo(modelChoiceStore.curId, false)
             // 取消知识库选中
             knowledgeChoiceStore.resetData()
            console.info('>>> 截图结果: ', data, imageData)
          }, '1001', "");
        }}
        className={[
          'flex items-center',
          'rounded-full cursor-pointer text-primary',
          'hover:bg-hover-normal',
          `!border-none bg-transparent p-6px ${globalStore.isDark ? 'hover:bg-[rgba(255,255,255,0.06)]' : 'hover:bg-black-6'}`,
          className,
        ]}
      >
        <SVGPureIcon
          name="screenshot_v2"
          className="size-18px"
        />
      </button>
    </Tooltip>
  );
}

export default observer(ScreenShot);